"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatMoney_1 = __importDefault(require("./formatMoney"));
exports.default = formatMoney_1.default;
//# sourceMappingURL=index.js.map